import { render, staticRenderFns } from "./UsersPrivilegePlacesWorkPlans.vue?vue&type=template&id=22293452&scoped=true&"
import script from "./UsersPrivilegePlacesWorkPlans.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegePlacesWorkPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22293452",
  null
  
)

export default component.exports